module.exports = __webpack_public_path__ + "static/media/41-iveco.5166e6a8.jpg";